// extracted by mini-css-extract-plugin
export var authenticatedSpacing = "styles-module__authenticatedSpacing___x4orT";
export var trailRiverPadding = "styles-module__trailRiverPadding___J6AKc";